import React from "react";
import { sortByPosition } from "../../helpers/helpers";
import CcList from "../ccList";
import CcTextAccordion from "../ccTextAccordion";

export const Text = ({ items }) => {

  return(
    items && (
      <CcList>
        {sortByPosition(items).map((item, index) => (
          <CcTextAccordion
            key={item.numberInOrder}
            text={item.content}
            isOpen={index === 0}
          />
        ))}
      </CcList>
    )
  );
};
